import { Box, Grid } from '@material-ui/core';
import InputField from 'components/InputField';
import ActionsButtons from 'containers/SignupPages/ActionsButtons';
import messages from 'containers/SignupPages/AuthByContractEpargnEmail/messages';
import { FormikProps, withFormik } from 'formik';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import validationSchema from 'containers/SignupPages/AuthByContractEpargnEmail/validationSchema';
import { get } from 'lodash';

const InnerForm = (props: FormProps & FormikProps<FormValues>) => {
  const {
    values,
    errors,
    handleSubmit,
    isLoading,
    onClickPrevious,
    handleBlur,
    handleChange,
    touched,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Box mb={3} paddingX={[4, 8, 12]}>
        <Grid container justify="center">
          <Grid xs={12} style={{ textAlign: 'center' }} item>
            <InputField
              name="email"
              label={translate({ ...messages.email }, props)}
              placeholder={translate({ ...messages.email }, props)}
              value={values.email}
              error={errors.email && touched.email}
              helperText={touched.email && errors.email}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          </Grid>
        </Grid>
      </Box>
      <ActionsButtons onClickPrevious={onClickPrevious} isLoading={isLoading} />
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoading: boolean;
  onClickPrevious: Function;
  onSubmitStep: Function;
}

interface FormValues {
  email: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: (props) => {
    const localData = localStorage.getItem('personalInfo');
    const data = localData && JSON.parse(localData);

    return {
      email: get(data, 'email', '') || '',
    };
  },

  validationSchema,
  handleSubmit: (values, { props, setFieldError }) => {
    return props.onSubmitStep(values);
  },
})(InnerForm);

export default injectIntl(Form);
